// SPDX-FileCopyrightText: 2026 Z-Meet contributors
// SPDX-License-Identifier: Apache-2.0

// Phần DỰNG GIAO DIỆN của emoji. Logic phân tích nằm ở src/emoji.ts.
//
// Tách hai file và đặt tên khác nhau, không phải emoji.ts + emoji.tsx: hai file
// cùng tên gốc làm `import from './emoji'` phân giải theo thứ tự phần mở rộng
// của bộ đóng gói, và thứ tự đó không hiện ra ở đâu trong mã.

import { CATALOG, emojiURL, emojiOnly, parse } from '../emoji'

const BY_NAME = new Map(CATALOG.map((e) => [e.name, e]))

/** Emoji dựng sẵn ở kích thước cho trước. */
export function Emoji({ name, size = 22 }: { name: string; size?: number }) {
  const e = BY_NAME.get(name)
  if (!e) return null
  return (
    <img
      className="emoji"
      src={emojiURL(name)}
      alt={e.fallback}
      // alt hiện ra khi ảnh hỏng, và đó là lý do nó là emoji Unicode tương
      // đương chứ không phải tên: người đọc vẫn hiểu ý, không thấy chữ "like".
      title={`:${e.name}:`}
      width={size}
      height={size}
      draggable={false}
    />
  )
}


/** Render một tin nhắn: emoji riêng thành ảnh, phần còn lại giữ nguyên chữ. */
export function RichText({ text }: { text: string }) {
  const big = emojiOnly(text)
  return (
    <>
      {parse(text).map((part, i) =>
        part.t === 'text' ? (
          <span key={i}>{part.v}</span>
        ) : (
          <Emoji key={i} name={part.v} size={big ? 40 : 22} />
        ),
      )}
    </>
  )
}
